import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';

import { ReportGeneration } from 'Common/ObjectHelper';
import { toastType, createToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers/';
import { CaseTypeReportForm } from './components/CaseTypeReportForm';
import { CaseTypeReportFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { CASE_TYPE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { getCaseTypeReport, clearReport } from './state/casetypereport/actions';
import { LoadingPage } from 'Components/loading/LoadingPage';

class CaseTypeReportContainer extends Component {
  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: CASE_TYPE_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  componentDidUpdate(prevProps, prevState) {
    const { report } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Case Type Report');
      }
      this.props.clearReport();
    }
  }

  handleSubmit = formValues => {
    this.props.getCaseTypeReport(formValues);
  };

  render() {
    return (
      <Fragment>
        {this.props.loading ? <LoadingPage /> : undefined}
        <Filter title={'Categorical Case Type Report'} />
        <Main {...this.getMainProps()}>
          <CaseTypeReportForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.AsOfDate]: defaultDateFormat(moment()),
              [Fields.SummaryOnly]: false,
              [Fields.SortBy]: 'LastnameFirst',
              [Fields.Site]: 'ALL',
              [Fields.CaseType]: 'ALL',
              [Fields.Grade]: 'ALL',
              [Fields.DCCat]: 'Both',
              [Fields.DCCat]: 'All',
              [Fields.GroupBy]: 'district',
            }}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.CaseTypeReportState.caseTypeReport.loading,
    report: state.CaseTypeReportState.caseTypeReport.report,
  };
};

export const CaseType = withRouter(
  connect(mapStateToProps, { getCaseTypeReport, clearReport })(
    CaseTypeReportContainer
  )
);



// WEBPACK FOOTER //
// ./src/pages/casetype/CaseType.js